import { render } from "./KontaktView.vue?vue&type=template&id=3de74ece&scoped=true"
import script from "./KontaktView.vue?vue&type=script&lang=js"
export * from "./KontaktView.vue?vue&type=script&lang=js"

import "./KontaktView.vue?vue&type=style&index=0&id=3de74ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de74ece"]])

export default __exports__